import { SelectHTMLAttributes } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import ExpandMoreIcon from 'svgIcons/ExpandMore'

type IFProps = SelectHTMLAttributes<HTMLSelectElement>

const Select: React.FC<IFProps> = ({ className, children, ...props }) => {
  return (
    <StyledWrapper className={className}>
      <select className="sort-select" {...props}>
        {children}
      </select>
      <div className="icon-arrow">
        <ExpandMoreIcon />
      </div>
    </StyledWrapper>
  )
}

export default Select

const StyledWrapper = styled.div`
  position: relative;
  display: inline-block;
  background-color: white;
  select {
    border: none;
    background-color: transparent;
    -o-appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: none;
    padding: 10px 25px 10px 15px;
    cursor: pointer;
  }

  border: 1px solid #e8e8e8;
  border-radius: 5px;
  font-size: 14px;
  .icon-arrow {
    top: 8px;
    bottom: 0;
    right: 5px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    svg {
      width: 10px;
      height: 10px;
    }
  }
`
